export default {"src":"/_next/static/media/bus_v4.912acc31.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};